import type { UiStrings } from "../types";

export const pt: UiStrings = {
  nav: {
    category: "Categoria",
    forYourWork: "Para o seu Trabalho",
    searchPlaceholder: "Busque entre mais de 300 ferramentas...",
    heroPlaceholder: "O que você tem em mente?",
  },
  trustBadges: {
    noLogin: "Sem login para usar as ferramentas",
    freeUsesDaily: "10 usos de teste por dia",
    filesNeverStored: "Seus arquivos nunca são armazenados",
    worksAnyDevice: "Funciona em qualquer dispositivo",
    worksWhenAiBlocked: "Funciona sob qualquer política de IA da sua empresa",
    availableInLanguages: "Disponível em vários idiomas",
  },
  common: {
    backToHome: "Voltar ao Início",
    home: "Início",
    signIn: "Entrar",
    account: "Conta",
    contact: "Contato",
    blog: "Blog",
    shareThisTool: "Compartilhar esta ferramenta",
    download: "Baixar",
    copy: "Copiar",
    copied: "Copiado",
  },
  footer: {
    tagline: "Sua plataforma completa de produtividade online. Mais de 300 ferramentas profissionais, aplicativos premium e produtos de fluxo de trabalho para o dia a dia.",
    company: "Empresa",
    about: "Sobre",
    blog: "Blog",
    contact: "Contato",
    pricing: "Preços",
    privacyPolicy: "Política de Privacidade",
    termsOfService: "Termos de Serviço",
    allTools: "Todas as Ferramentas",
    allRightsReserved: "Todos os direitos reservados.",
  },
  contact: {
    title: "Fale Conosco",
    subtitle: "Dúvidas, sugestões ou algo não está funcionando direito? Estamos aqui para ajudar.",
    email: "E-mail",
    responseTime: "Tempo de Resposta",
    responseTimeValue: "Normalmente respondemos em 1-2 dias úteis.",
    sendEmail: "Envie-nos um e-mail",
    billingNote: "Para dúvidas sobre cobrança, inclua o e-mail associado à sua conta.",
    whoWeAreTitle: "Quem opera o FreeDailyPro",
    whoWeAreBody: "O FreeDailyPro é operado pela DreamUSA LLC, uma pequena empresa de software gerenciada de forma independente. Não há uma grande equipe de suporte por trás disso -- a pessoa que lê e responde seu e-mail também é quem constrói e mantém as ferramentas, por isso uma resposta às vezes leva um ou dois dias em vez de ser instantânea.",
    whatWeSupportTitle: "Com o que podemos ajudar",
    whatWeSupportBody: "Relatos de bugs de qualquer uma das mais de 300 ferramentas, pedidos de recursos, questões de cobrança e assinatura (incluindo cancelamentos e reembolsos), problemas de conta e login, e feedback geral sobre o que está funcionando bem ou não. Se uma ferramenta produziu um resultado incorreto, informar o tipo de arquivo e o que deu errado ajuda a corrigir mais rápido.",
  },
  home: {
    heroTitleLine1: "Cada tarefa profissional.",
    heroTitleLine2: "Uma plataforma no navegador",
    heroSubtitle: "Use uma ferramenta. Execute um fluxo de trabalho. Crie com API e MCP. Ou deixe que criemos para você.",
    localSignalUsedTitle: "Usadas neste dispositivo",
    localSignalTryTitle: "Experimente uma destas",
    localSignalBadge: "Local \u00b7 Sem rede",
    localSignalUsedDesc: "ferramentas usadas neste dispositivo \u2014 nada saiu do seu navegador",
    localSignalTryDesc: "ferramentas usadas até agora neste dispositivo \u2014 tudo roda aqui mesmo, no seu navegador",
    corporateSafeTitle: "Seguro para empresas",
    corporateSafeSubtitle: "Seja qual for a política de IA da sua empresa, o FreeDailyPro funciona igual",
    corporateSafeBlockedTitle: "Totalmente bloqueado",
    corporateSafeBlockedDesc: "Nenhum tipo de ferramenta de IA é permitido na rede. Todas as ferramentas do FreeDailyPro continuam funcionando \u2014 nada é enviado a um servidor.",
    corporateSafeGovernedTitle: "Acesso controlado",
    corporateSafeGovernedDesc: "IA só é permitida por meio de ferramentas aprovadas e verificadas. Aqui não é preciso aprovação nenhuma \u2014 não há chamada a servidor externo para verificar.",
    corporateSafeOpenTitle: "Sem restrições",
    corporateSafeOpenDesc: "Use o que resolver o problema. O FreeDailyPro é simplesmente mais rápido, já que não há nada para enviar ou esperar.",
    corporateSafeCta: "Ver o detalhamento completo para empresas \u2192",
    exploreToolkitTitle: "Explore as ferramentas",
    exploreToolkitSubtitle: "Mais de 300 ferramentas em {catCount} categorias \u2014 escolha uma, ou apenas pesquise.",
    forYourWorkTitle: "Feito para como você realmente trabalha",
    forYourWorkSubtitle: "As mesmas ferramentas profissionais, organizadas de acordo com o seu trabalho",
    exploreTools: "Explorar ferramentas",
    seeAllRoles: "Ver todas as {count} funções \u2192",
    blogTitle: "Do Blog",
    viewAllPosts: "Ver Todas as Publicações",
    faqTitle: "Tem uma dúvida? Confira nosso FAQ",
    faqMoreLink: "Procurando mais respostas? Veja o FAQ completo \u2192",
    toolkitProseTitle: "Um kit de ferramentas profissional feito para o trabalho diário, não só tarefas pontuais",
    closingCtaTitle: "Não esqueça de adicionar o atalho",
    closingCtaDesc: "Adicione uma vez e ele estará sempre a um clique \u2014 instale o atalho no desktop ou adicione à tela inicial do seu celular, e o FreeDailyPro abrirá como um app nativo, sem precisar procurar abas do navegador.",
    categoriesLabel: "{count} CATEGORIAS \u2192",
    viewAllCategoriesLabel: "VER TODAS AS {count} CATEGORIAS \u2192",
    yourFavorites: "Seus Favoritos",
    recentlyUsed: "Usados Recentemente",
    toolkitProsePara1: "O FreeDailyPro reúne mais de 300 ferramentas do dia a dia \u2014 edição de PDF, conversão de imagens, corte de vídeo, limpeza de áudio, formatação de texto e dezenas de calculadoras \u2014 em um só lugar, para você não ficar pulando de site em site para cada tarefa. A maioria das ferramentas não exige cadastro, e as ferramentas baseadas em arquivo incluem 10 usos gratuitos por dia.",
    toolkitProsePara2: "Cada ferramenta roda completamente no seu navegador. Ao compactar um PDF ou remover o fundo de uma foto, esse arquivo nunca sai do seu dispositivo \u2014 não é enviado, processado em um servidor, nem armazenado em nenhum lugar, nem mesmo temporariamente. Isso não é uma limitação, é todo o design: resultados mais rápidos, e nada com que se preocupar se o arquivo for sensível.",
    toolkitProsePara3: "Essa abordagem local também significa que o FreeDailyPro funciona igual em um laptop pessoal, em uma máquina de trabalho restrita, ou em uma rede com políticas rígidas de uso de IA \u2014 não há nenhuma chamada a servidor externo para o TI avaliar, porque ela simplesmente não existe.",
    toolkitProsePara4: "Seja para juntar PDFs em um relatório, redimensionar uma imagem para um anúncio, cortar um clipe de vídeo para redes sociais, ou fazer um cálculo rápido de financiamento ou impostos, o FreeDailyPro foi feito para ser a ferramenta que você usa todo dia \u2014 não só aquela que você lembra que existe quando precisa.",
    heroLaneToolsTitle: "Ferramentas profissionais para tarefas individuais",
    heroLaneToolsDesc: "PDF, imagem, vídeo e mais -- uma ação, feita no seu navegador.",
    heroLaneToolsCta: "Explorar ferramentas",
    heroLanePremiumTitle: "Aplicativos premium para trabalhos maiores",
    heroLanePremiumDesc: "Apps de várias etapas: documentos, formulários, planejadores, impressão e eventos.",
    heroLanePremiumCta: "Ver aplicativos",
    heroLaneWorkflowTitle: "Produtos de fluxo de trabalho",
    heroLaneWorkflowDesc: "Book Writing Toolbox, Event Suite e mais -- várias etapas, um resultado.",
    heroLaneWorkflowCta: "Ver produtos de fluxo de trabalho",
    heroLaneApiTitle: "API e MCP",
    heroLaneApiDesc: "Chame as mesmas ferramentas a partir do seu próprio código ou agente de IA.",
    heroLaneApiCta: "Abrir desenvolvedores",
    heroLaneCustomTitle: "Software sob medida",
    heroLaneCustomDesc: "Conte-nos o que você precisa. Desenvolvemos por um valor único e depois você paga uma pequena taxa mensal de uso.",
    heroLaneCustomCta: "Solicitar desenvolvimento",
  },
  install: {
    desktopTitle: "Atalho de Desktop",
    desktopSubtitle: "Um clique, abre na hora",
    mobileTitle: "App Móvel",
    mobileSubtitle: "Adicione à sua tela inicial",
    addToHomeScreenTitle: "Adicione o FreeDailyPro à sua Tela Inicial",
    iosInstructions: "Toque no ícone Compartilhar no Safari e escolha \"Adicionar à Tela de Início.\"",
    genericInstructions: "Abra o menu do seu navegador e procure por \"Adicionar à tela inicial\" ou \"Instalar app.\"",
    desktopUnavailableTitle: "A instalação em um clique não está disponível neste navegador",
    desktopUnavailableDesc: "Você ainda pode salvar esta página nos favoritos, ou arrastar o ícone da barra de endereços para o desktop.",
    desktopSuccess: "Atalho criado! Procure pelo ícone do FreeDailyPro.",
    mobileSuccess: "Adicionado! Procure pelo ícone do FreeDailyPro na sua tela inicial.",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "{count} usos de teste restantes hoje",
    whatThisToolDoes: "O que esta ferramenta faz",
    proTips: "Dicas Pro",
    continueWith: "Continue com",
    moreFromCategory: "Mais desta categoria",
  },
  usageStrip: {
    freeUsesPerDay: "Teste: {limit} usos/dia",
    remainingToday: "{count} restantes hoje",
    dayPassLabel: "Uso ilimitado sem anúncios, passe de 1 dia por $1",
    monthlyLabel: "Uso ilimitado sem anúncios, passe mensal por $4.99",
    quickBuy: "Compra rápida",
  },
  platformsBanner: {
    title: "Onde essa API realmente está",
    subtitle: "Não é uma página que diz \"em breve\" -- são listagens reais e funcionais às quais você pode se inscrever ou conectar hoje.",
    postmanDetail: "Requisições prontas para usar, totalmente documentadas",
    rapidApiDetail: "Assine com cobrança por uso através do marketplace da Rapid",
    mcpRegistryDetail: "Listado oficialmente como com.freedailypro/tools, {mcp} ferramentas, um único endpoint",
  },
  pricingBanner: {
    title: "Preços transparentes",
    subtitle: "Sem níveis ocultos nem limites surpresa -- exatamente o que cada plano custa e o que você recebe.",
    toolPricingTitle: "Preços de ferramentas por uso",
    apiPricingTitle: "Preços de API e MCP por uso",
    freeLabel: "Teste",
    freeToolDetail: "10 usos/dia em Professional Tools, 2 em Premium Applications",
    dayPassDetail: "$1/dia -- uso ilimitado sem anúncios",
    monthlyDetail: "$4.99/mês -- uso ilimitado sem anúncios",
    monthlySavingsNote: "Mais barato que 5 passes diários por mês",
    freeApiDetail: "20.000 chamadas/mês",
    premiumDetail: "$24/mês -- 200.000 chamadas",
    ultraDetail: "$69/mês -- 750.000 chamadas",
    megaDetail: "$129/mês -- 2.000.000 chamadas + prioridade",
  },
  apiMcpBanner: {
    title: "Agora com API e MCP",
    description: "Chame nossas mais de 200 ferramentas diretamente do seu próprio código, ou conecte um agente de IA via MCP -- as mesmas ferramentas, no lado do servidor, para quando só o navegador não for suficiente.",
    oneKey: "Uma única chave para tudo",
    restApiMcp: "API REST + MCP",
    anyLanguage: "Qualquer linguagem, qualquer servidor",
    cta: "Explorar a API e MCP",
  },
  premiumApps: {
    title: "Aplicativos Premium",
    subtitle: "Aplicativos reais de múltiplas etapas, não ferramentas de ação única -- também instaláveis separadamente.",
    seeAll: "Ver todos os aplicativos Premium",
  },
  googleDrive: {
    openFromGoogle: "Abrir do Google Drive",
    saveToGoogle: "Salvar no Google Drive",
    signingIn: "Abrindo o login do Google...",
    fetching: "Obtendo seu arquivo do Google Drive...",
    saving: "Salvando no Google Drive...",
    saved: "Salvo no Google Drive",
    viewInDrive: "Ver no Drive",
    popupBlocked: "Seu navegador bloqueou a janela de login do Google. Permita pop-ups neste site e tente de novo.",
    cancelled: "O login do Google foi fechado antes de terminar. Nada foi aberto ou salvo.",
    denied: "O acesso ao Google Drive não foi permitido, então nada foi aberto ou salvo. Tente de novo e permita o acesso aos arquivos que você escolher.",
    loadFailed: "Não foi possível conectar ao Google. Verifique sua conexão ou bloqueador de conteúdo e tente de novo.",
    network: "A conexão com o Google Drive caiu. Tente de novo.",
    tooLarge: "Esse arquivo é grande demais para abrir no navegador.",
    api: "O Google Drive não conseguiu concluir a ação. Tente de novo.",
    largeFile: "Este arquivo tem mais de 50 MB. Pode demorar mais ou esgotar a memória do navegador.",
    privacyNote: "Seu arquivo vai entre o navegador e o Google. Ele não é enviado aos nossos servidores.",
  },
};
